import createIcon from '../../createIcon';

/**
 * @component @name Contacts
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMEg0VjJIMjBWMFpNNCAyNEgyMFYyMkg0VjI0Wk0yMCA0SDRDMi45IDQgMiA0LjkgMiA2VjE4QzIgMTkuMSAyLjkgMjAgNCAyMEgyMEMyMS4xIDIwIDIyIDE5LjEgMjIgMThWNkMyMiA0LjkgMjEuMSA0IDIwIDRaTTEyIDYuNzVDMTMuMjQgNi43NSAxNC4yNSA3Ljc2IDE0LjI1IDlDMTQuMjUgMTAuMjQgMTMuMjQgMTEuMjUgMTIgMTEuMjVDMTAuNzYgMTEuMjUgOS43NSAxMC4yNCA5Ljc1IDlDOS43NSA3Ljc2IDEwLjc2IDYuNzUgMTIgNi43NVpNMTcgMTdIN1YxNS41QzcgMTMuODMgMTAuMzMgMTMgMTIgMTNDMTMuNjcgMTMgMTcgMTMuODMgMTcgMTUuNVYxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Contacts = createIcon('Contacts', [
  [
    'path',
    {
      d: 'M20 0H4V2H20V0ZM4 24H20V22H4V24ZM20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM12 6.75C13.24 6.75 14.25 7.76 14.25 9C14.25 10.24 13.24 11.25 12 11.25C10.76 11.25 9.75 10.24 9.75 9C9.75 7.76 10.76 6.75 12 6.75ZM17 17H7V15.5C7 13.83 10.33 13 12 13C13.67 13 17 13.83 17 15.5V17Z',
      key: '1j3vsa',
    },
  ],
]);

export default Contacts;
